import { useMemo, useEffect } from "react";

export function usePagedRows(rows, currentPage, pageSize) {
  return useMemo(() => {
    const start = (currentPage - 1) * pageSize;
    return rows.slice(start, start + pageSize);
  }, [rows, currentPage, pageSize]);
}

/** Keeps currentPage valid when filters shrink the list */
export function useClampPage(rowCount, currentPage, pageSize, setCurrentPage) {
  useEffect(() => {
    const maxPage = Math.max(1, Math.ceil(rowCount / pageSize) || 1);
    if (currentPage > maxPage) setCurrentPage(maxPage);
  }, [rowCount, pageSize, currentPage, setCurrentPage]);
}
